import React from "react";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";

const toDayjs = (value) => {
    if (value === undefined || value === null || value === "") return null;
    if (dayjs.isDayjs(value)) return value.isValid() ? value : null;
    const d = dayjs(value);
    return d.isValid() ? d : null;
};

const AppDateTimePicker = ({
    label,
    name,
    value,
    onChange,
    helperText,
    error = false,
    required = false,
    disabled = false,
    readOnly = false,
    minDate,
    maxDate,
    minDateTime,
    maxDateTime,
    fullWidth = true,
    size = "medium",
    format = "MM/DD/YYYY hh:mm A",
    slotProps,
    ...rest
}) => {
    const handleChange = (next) => {
        if (typeof onChange !== "function") return;
        if (next && dayjs.isDayjs(next) && next.isValid()) {
            onChange(next.format("YYYY-MM-DDTHH:mm"), name);
        } else {
            onChange("", name);
        }
    };

    const callerTextFieldSlot = (slotProps && slotProps.textField) || {};
    const mergedSlotProps = {
        ...(slotProps || {}),
        textField: {
            name,
            fullWidth,
            size,
            required,
            error,
            helperText,
            ...callerTextFieldSlot,
        },
    };

    return (
        <DateTimePicker
            label={label}
            value={toDayjs(value)}
            onChange={handleChange}
            format={format}
            disabled={disabled}
            readOnly={readOnly}
            minDate={toDayjs(minDate) || undefined}
            maxDate={toDayjs(maxDate) || undefined}
            minDateTime={toDayjs(minDateTime) || undefined}
            maxDateTime={toDayjs(maxDateTime) || undefined}
            slotProps={mergedSlotProps}
            {...rest}
        />
    );
};

export default AppDateTimePicker;
